import React, { useEffect, useState } from 'react';
import {Image} from '@shopify/hydrogen';
import 'rc-slider/assets/index.css';
import arrowSearch from '../../../../assets/image/arrow-search.svg';
import { useAppDispatch, useAppSelector } from '../../../../lib/hooks';
import { calculateNewOptions } from '../../common/utils';
import { executeSearch, updateFilters, triggerFilterOnPress } from '../../../../store/slices/search';
import { sendEvent } from '../../../../lib/analitycs';
import { appendValueToUrlParam } from '../../../../lib/Utils'

export default function TagList({title, apiSection}) {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.search)?.response;
  const filtersActive = useAppSelector((state) => state.search)?.filters;
  const [isActive, setIsActive] = useState(false);
  const [optionsList, setOptionList] = useState([]);
  const [currentOptionList, setCurrentOptionList] = useState([]);
  const [hideViewMore, setHideViewMore] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  

  const toggleOpen = ()=>{
    setIsActive(!isActive);
  }

  const filtersOrdered = ()=>{
    if(filters[apiSection]){
      let filtersOrderned = filters[apiSection].slice();
      return filtersOrderned.slice().sort((a, b) => b.matched - a.matched); 
    }else{
      return [];
    }
  }

  const loadMore = ()=>{
    let list = calculateNewOptions(optionsList, currentOptionList, 10);
    if(list.length === optionsList.length){
      setHideViewMore(true);
    }
    setCurrentOptionList(list);
  }

  const tagClick = (index)=>{
    if(selectedTags.some(currentIndex => currentIndex === index)){
      // uncheck tag
      setSelectedTags(selectedTags.filter(indexItem => indexItem !== index));
    }else{
      // check tag
      setSelectedTags([...selectedTags, index]);
    }

    let itemName = currentOptionList[index].item;
    appendValueToUrlParam(apiSection, itemName);

    setTimeout(()=>{ dispatch(executeSearch()); }, 1000);
  }

  const trackEvent = (value)=>{
    sendEvent('filter_interaction',{
      filter_option : apiSection,
      option_selected: decodeURIComponent(value),
    });
  }

  const cutNameLabel = (name)=>{
    if (!name) {
      return '';
    }

    if (name.length > 20) {
      return name.substring(0, 20) + '...';
    }
    return name;
  }

  useEffect(()=>{
    if(filters[apiSection]){
      let filtersOrderned = filters[apiSection].slice();
      filtersOrderned = filtersOrderned.slice().sort((a, b) => b.matched - a.matched);

      setCurrentOptionList(calculateNewOptions(filtersOrderned, currentOptionList, 10))
      setOptionList(filtersOrderned);

      if(filtersOrderned.length < 10){
        setHideViewMore(true);
      }
    }
  },[filters])

  useEffect(()=>{
    if(filtersActive[apiSection]){
      const findIndex = (list, value)=>{
        let index = 0;
        for(let item of list){ if(item.item === value){ return index;}else{index++;}}
      }

      let finalSel = selectedTags;
      for(let value of filtersActive[apiSection]){
        let index = findIndex(optionsList, value);
        finalSel.push(index);
      }
      setSelectedTags(finalSel);
    }
  },[optionsList])

  useEffect(()=>{
    try{
      dispatch(updateFilters({
        section: apiSection, 
        value: selectedTags.map(index => filtersOrdered()[index].item)
      }))
    }catch(e){}
  },[selectedTags])

  return (
    <>
      <div className="filter-item border-b px-10 py-3 ">
      <div 
          className={`
            accordion-header font-semibold text-lg flex justify-between cursor-pointer 
            ${!isActive ? 'accordion-close' : 'accordion-open'}
            `}
            onClick={toggleOpen}
        >
          <label> {title} </label>
          <Image
            src={arrowSearch}
            height={5}
            width={10}
            className="inline icon-arrow-down"
            alt="Search"
            style={{
              transform: isActive ? 'rotate(0deg)' : 'rotate(-90deg)',
            }}
          />
        </div>
        <div className={`
            accordion-content flex flex-wrap w-full
            ${!isActive ? 'hidde-accordeon' : ''}
          `}>
              <div className='general-box-content'>
                {currentOptionList.map((name, index)=>(
                  <button 
                    key={index}
                    onClick={(e)=>{trackEvent(name.item); tagClick(index); dispatch(triggerFilterOnPress());}}
                    className={`${selectedTags.includes(index) ? 'tag-active': 'tag-inactive' } tag-item rounded-full relative px-2 py-1 m-1 bg-white border-purple-120 border inline text-sm`}
                    title={name.item}
                  >
                    {cutNameLabel(name.item)}<span> ({name.matched}) </span>
                  </button>
                ))}
                <button 
                  className={`tag-item rounded-full relative px-2 py-1 m-1 bg-white 
                              border-purple-120 border inline text-sm ${hideViewMore ? 'hide' : ''}`}
                  onClick={loadMore}
                >
                    Ver más
                </button>
              </div>
        </div>
      </div>
    </>
  );
}
